import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=156bf9b3&scoped=true&"
import script from "./memberCard.vue?vue&type=script&lang=js&"
export * from "./memberCard.vue?vue&type=script&lang=js&"
import style0 from "./memberCard.vue?vue&type=style&index=0&id=156bf9b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156bf9b3",
  null
  
)

export default component.exports